import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["children", "accessibilityLabel", "url", "newWindow", "onClick", "stopPropagation", "preserveUrlQuery", "excludeFromUrlQuery", "attributes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import { LinkContext } from "../../../context/link.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var Link = function Link(_ref) {
  var children = _ref.children,
    _ref$accessibilityLab = _ref.accessibilityLabel,
    accessibilityLabel = _ref$accessibilityLab === void 0 ? '' : _ref$accessibilityLab,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
    _ref$onClick = _ref.onClick,
    onClickParent = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? false : _ref$stopPropagation,
    _ref$preserveUrlQuery = _ref.preserveUrlQuery,
    preserveUrlQuery = _ref$preserveUrlQuery === void 0 ? false : _ref$preserveUrlQuery,
    _ref$excludeFromUrlQu = _ref.excludeFromUrlQuery,
    excludeFromUrlQuery = _ref$excludeFromUrlQu === void 0 ? [] : _ref$excludeFromUrlQu,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var onClick = function onClick(e) {
    if (stopPropagation) {
      e.stopPropagation();
    }
    onClickParent(e);
  };
  var Component = useContext(LinkContext);
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    target: newWindow ? '_blank' : '',
    onClick: onClick,
    to: url
  }, accessibilityLabel ? {
    'aria-label': accessibilityLabel
  } : {}), attributes), otherProps), {}, {
    children: children
  }));
};